import { render, staticRenderFns } from "./ReportNavigation.vue?vue&type=template&id=2de84e83&scoped=true"
import script from "./ReportNavigation.vue?vue&type=script&lang=js"
export * from "./ReportNavigation.vue?vue&type=script&lang=js"
import style0 from "./ReportNavigation.vue?vue&type=style&index=0&id=2de84e83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de84e83",
  null
  
)

export default component.exports